import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UpdateState } from '../reducers/update.reducer';
import { UPDATE_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<UpdateState>(UPDATE_FEATURE_KEY);

export const selectStatus = createSelector(selectState, (state: UpdateState) => state.status);

export const selectBundleId = createSelector(selectState, (state: UpdateState) => state.bundleId);

export const selectVersion = createSelector(selectState, (state: UpdateState) => state.version);

export const selectPending = createSelector(selectStatus, (status) => status === 'pending');
